import script from "./NewAlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./NewAlertModal.vue?vue&type=script&setup=true&lang=js"

import "./NewAlertModal.vue?vue&type=style&index=0&id=ab68d150&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab68d150"]])

export default __exports__